/**
 * @generated SignedSource<<c55c7348bce8532191785506b0a174e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ParticipantPaymentModal_study$data = {
  readonly tenant: {
    readonly stripePaymentMethodId: string | null;
    readonly stripePaymentMethodLast4: string | null;
  };
  readonly " $fragmentType": "ParticipantPaymentModal_study";
};
export type ParticipantPaymentModal_study$key = {
  readonly " $data"?: ParticipantPaymentModal_study$data;
  readonly " $fragmentSpreads": FragmentRefs<"ParticipantPaymentModal_study">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipantPaymentModal_study",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TenantNode",
      "kind": "LinkedField",
      "name": "tenant",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stripePaymentMethodId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stripePaymentMethodLast4",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StudyNode",
  "abstractKey": null
};

(node as any).hash = "510b1bf3bd5fc8f2d02f92042aa222d3";

export default node;
